// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function () {
      var title = this.htmlTitle  //DPF标题
      // 注册getPdf方法，传入两个参数，此处使用了promise处理导出后的操作
      /*
      title: 导出文件名
      dom: 需要导出dom的id
       */
      return new Promise((resolve, reject) => {
        html2Canvas(document.querySelector('#pdfDom'), {
          allowTaint: true,
          taintTest: false,
          useCORS: true,
          //width:960,
          //height:5072,
          dpi: window.devicePixelRatio*4, //将分辨率提高到特定的DPI 提高四倍
          scale:4 //按比例增加分辨率
        }).then(function (canvas) {
          let pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向
          let ctx = canvas.getContext('2d'),
            a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
            imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
            renderedHeight = 0;

          while(renderedHeight < canvas.height) {
            let page = document.createElement("canvas");
            page.width = canvas.width;
            page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

            //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
            pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

            renderedHeight += imgHeight;
            if(renderedHeight < canvas.height) {
              pdf.addPage();//如果后面还有内容，添加一个空页
            }
            delete document.createElement("canvas");
          }
          //保存文件
          pdf.save(title + '.pdf')
          resolve(true);
        }).catch(() => {
            reject(false);
          });
      });
    };
  }
}


// Vue.prototype.getPdf = function () {
//   var title = this.htmlTitle  //DPF标题
//   html2Canvas(document.querySelector('#pdfDom'), {
//     allowTaint: true,
//     taintTest: false,
//     useCORS: true,
//     //width:960,
//     //height:5072,
//     dpi: window.devicePixelRatio*4, //将分辨率提高到特定的DPI 提高四倍
//     scale:4 //按比例增加分辨率
//   }).then(function (canvas) {
//       var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向
//       var ctx = canvas.getContext('2d'),
//         a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
//         imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
//         renderedHeight = 0;
//
//       while(renderedHeight < canvas.height) {
//         var page = document.createElement("canvas");
//         page.width = canvas.width;
//         page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页
//
//         //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
//         page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
//         pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距
//
//         renderedHeight += imgHeight;
//         if(renderedHeight < canvas.height) {
//           pdf.addPage();//如果后面还有内容，添加一个空页
//         }
//         delete document.createElement("canvas");
//       }
//       //保存文件
//       pdf.save(title + '.pdf')
//
//     }
//   )
// }

// let contentWidth = canvas.width
// let contentHeight = canvas.height
// let pageHeight = contentWidth / 592.28 * 841.89
// let leftHeight = contentHeight
// let position = 0
// let imgWidth = 595.28
// let imgHeight = 592.28 / contentWidth * contentHeight
// let pageData = canvas.toDataURL('image/jpeg', 1.0)
// let PDF = new JsPDF('', 'pt', 'a4')
// if (leftHeight < pageHeight) {
//   PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
// } else {
//   while (leftHeight > 0) {
//     PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
//     leftHeight -= pageHeight
//     position -= 841.89
//     if (leftHeight > 0) {
//       PDF.addPage()
//     }
//   }
// }
// PDF.save(title + '.pdf')


/**jspdf将html转为pdf一页显示不截断，整体思路：
 * 1. 获取DOM
 * 2. 将DOM转换为canvas
 * 3. 获取canvas的宽度、高度（稍微大一点）
 * 4. 将pdf的宽高设置为canvas的宽高
 * 5. 将canvas转为图片
 * 6. 实例化jspdf，将内容图片放在pdf中（因为内容宽高和pdf宽高一样，就只需要一页，也防止内容截断问题）
 */

  // 得到canvas画布的单位是px 像素单位
// var contentWidth = canvas.width
// var contentHeight = canvas.height
//
// console.log('contentWidth', contentWidth)
// console.log('contentHeight', contentHeight)
// // 将canvas转为base64图片
// var pageData = canvas.toDataURL('image/jpeg', 1.0)
//
// // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75   pt = (px/scale)* 0.75
// // 2为上面的scale 缩放了2倍
// var pdfX = (contentWidth + 10) / 4 * 0.75
// var pdfY = (contentHeight + 500) / 4 * 0.75 // 500为底部留白
//
// // 设置内容图片的尺寸，img是pt单位
// var imgX = pdfX;
// var imgY = (contentHeight / 4 * 0.75); //内容图片这里不需要留白的距离
//
// // 初始化jspdf 第一个参数方向：默认''时为纵向，第二个参数设置pdf内容图片使用的长度单位为pt，第三个参数为PDF的大小，单位是pt
// var PDF = new JsPDF('', 'pt', [pdfX, pdfY])
//
// // 将内容图片添加到pdf中，因为内容宽高和pdf宽高一样，就只需要一页，位置就是 0,0
// PDF.addImage(pageData, 'jpeg', 0, 0, imgX, imgY)
// PDF.save(title + '.pdf')
